import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const getSessionId = () => {
  const tabId = sessionStorage.getItem('analytics_tab_id') || 
    `tab-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  sessionStorage.setItem('analytics_tab_id', tabId);
  
  const deviceId = localStorage.getItem('analytics_device_id') || 
    `device-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  localStorage.setItem('analytics_device_id', deviceId);
  
  return `${deviceId}_${tabId}`;
};

export const usePageTracking = () => {
  const location = useLocation();
  const sessionId = useRef(getSessionId());
  const entryTime = useRef<number>(Date.now());

  useEffect(() => {
    const trackPageView = async () => {
      try {
        const now = new Date().toISOString();
        
        await supabase.functions.invoke('track-analytics', {
          body: {
            sessionId: sessionId.current,
            pagePath: location.pathname,
            entryTime: new Date(entryTime.current).toISOString(),
            lastActivity: now,
            userAgent: navigator.userAgent,
            referrer: document.referrer || null
          }
        });

        // Geo lookup: uma vez por sessão. A flag só é gravada após sucesso,
        // assim uma falha pontual é reprocessada na próxima navegação.
        const geoState = sessionStorage.getItem('geo_tracked');
        if (geoState !== 'ok' && geoState !== 'pending') {
          sessionStorage.setItem('geo_tracked', 'pending');
          supabase.functions
            .invoke('track-geo-location', { body: { sessionId: sessionId.current } })
            .then(({ error }) => {
              sessionStorage.setItem('geo_tracked', error ? 'failed' : 'ok');
            })
            .catch(() => sessionStorage.setItem('geo_tracked', 'failed'));
        }

      } catch {
        // Silently ignore tracking errors
      }
    };

    trackPageView();

    const interval = setInterval(async () => {
      try {
        await supabase.functions.invoke('track-analytics', {
          body: {
            sessionId: sessionId.current,
            pagePath: location.pathname,
            entryTime: new Date(entryTime.current).toISOString(),
            lastActivity: new Date().toISOString(),
            userAgent: navigator.userAgent,
            referrer: document.referrer || null
          }
        });
      } catch {}
    }, 30000);

    return () => {
      clearInterval(interval);
      const exitTime = Date.now();
      const timeSpent = Math.floor((exitTime - entryTime.current) / 1000);
      
      supabase.functions.invoke('track-analytics', {
        body: {
          sessionId: sessionId.current,
          pagePath: location.pathname,
          entryTime: new Date(entryTime.current).toISOString(),
          lastActivity: new Date(exitTime).toISOString(),
          userAgent: navigator.userAgent,
          referrer: document.referrer || null,
          exitTime: new Date(exitTime).toISOString(),
          timeSpentSeconds: timeSpent
        }
      }).then(() => {
        entryTime.current = exitTime;
      });
    };
  }, [location.pathname]);
};
